import CheckoutView from "./view";
import { useSelector } from "react-redux";
import { ReducersTypes } from "../../redux/reducers/Models";
import { PropsView as PropsHome } from "../home/Models";
import useRedirect from "@/hooks/useRedirect";
import { useNavigate } from "react-router-dom";
import { getFormattedCart } from "@/utils/functions";
import { FormattedDebts } from "@/utils/transform";

export default function Checkout() {
  useRedirect("checkout");

  const navigate = useNavigate();

  const user = useSelector((state: ReducersTypes & {
    userReducer: ReducersTypes['userReducer'] & {
      cart: PropsHome['selectables']
    }
  }) => state.userReducer);

  const goToCard = () => navigate('/checkout/card');
  const goToPix = () => navigate('/checkout/pix');
  const goBack = () => navigate(-1);

  const cart = user?.cart?.filter(item => item.checked) ?? [];
  const debts = (user?.debts as FormattedDebts[]) ?? [];
  const { total, filteredItems } = getFormattedCart({ debts, cart });
  const plate = user?.plate ?? "";

  const passagesTotal = filteredItems?.reduce(
    (sum, item) => sum + (item?.original?.valorPassagem ?? 0), 0
  ) ?? 0;

  const finesTotal = filteredItems?.reduce(
    (sum, item) => sum + (item?.original?.vlMulta ?? 0), 0
  ) ?? 0;

  return (
    <CheckoutView
      goToCard={goToCard}
      goToPix={goToPix}
      goBack={goBack}
      plate={plate}
      total={total}
      passagesTotal={passagesTotal}
      finesTotal={finesTotal}
    />
  );
}
